import React, { useState } from "react";
import { LabelContainer } from "./Label.style";
import LabelTooltip from "../label-tooltip";

interface LabelProps {
  className?: string;
  htmlFor?: string;
  withTooltip?: boolean;
  tooltipTitle?: string;
  tooltipIconLeft?: string;
}

const Label: React.FC<LabelProps> = ({
  children,
  className,
  htmlFor = "",
  withTooltip,
  tooltipTitle,
  tooltipIconLeft,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <>
      <LabelContainer htmlFor={htmlFor} className={className}>
        {children}
      </LabelContainer>
      {withTooltip && (
        <LabelTooltip
          showTooltip={() => setShowTooltip(true)}
          hideTooltip={() => setShowTooltip(false)}
          tooltipTitle={tooltipTitle}
          isTooltipVisible={showTooltip}
          tooltipIconTop="-25px"
          tooltipIconLeft={tooltipIconLeft}
        />
      )}
    </>
  );
};

export default Label;
